export default __webpack_public_path__ + "static/media/down-collapse-dark.47d2cf1f.svg";